import angular from 'angular'

import utils from './utils'
import utilsDate from './utils.date'
import utilsMath from './utils.math'
import utilsLimit from './utils.limit'
import toaster from './toaster'
import optionsHandler from './optionsHandler'
import valueHandler from './valueHandler'
import storageHandler from './storageHandler'
import matcher from './matcher.service'

const name = 'utilsModule'

angular.module(name, [])
  .service('utilsDate', utilsDate)
  .service('utilsMath', utilsMath)
  .service('utilsLimit', utilsLimit)
  .service('toaster', toaster)
  .service('optionsHandler', optionsHandler)
  .service('valueHandler', valueHandler)
  .service('storageHandler', storageHandler)
  .service('matcher', matcher)
  .service('utils', utils)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/utils.module.js